import React, { useState, useEffect } from 'react';
import "../pages/css/DashBoard.css";
import Header from '../pages/components/Header';
import SideBar from '../pages/components/SideBar';
import { getDatabase, ref, get, update } from "firebase/database";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { motion } from 'framer-motion';
import UserVerification from '../pages/components/UserVerification';
import { useNavigate } from "react-router-dom";
import { Table, Button } from 'react-bootstrap';
import { FaUser, FaEnvelope, FaPhone, FaCheckCircle, FaTimesCircle, FaMoneyBill } from 'react-icons/fa';
import Swal from 'sweetalert2';

function AdminDashBoard() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [leads, setLeads] = useState([]);
  const navigate = useNavigate();

  UserVerification();

  const toggleSidebar = () => setIsSidebarOpen(prev => !prev);

  useEffect(() => {
    const db = getDatabase();
    const usersRef = ref(db, "blackstone-users/");

    get(usersRef).then(snapshot => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const formattedData = Object.keys(data).map(uid => ({
          uid,
          ...data[uid]
        }));
        setLeads(formattedData);
      }
    }).catch(error => {
      console.error("Error fetching users:", error);
    });
  }, []);

  // ✅ Change Status Function
  const handleStatusChange = async (uid, currentStatus) => {
    const db = getDatabase();
    const userRef = ref(db, `blackstone-users/${uid}`);
    const newStatus = currentStatus === "NonVerified" ? "Verified" : "NonVerified";

    try {
      await update(userRef, { status: newStatus, verified: newStatus === "Verified" });
      setLeads(prev =>
        prev.map(user => user.uid === uid ? { ...user, status: newStatus, verified: newStatus === "Verified" } : user)
      );
      Swal.fire("✅ Success", `Status changed to ${newStatus}`, "success");
    } catch (error) {
      console.error("Error updating status:", error);
      Swal.fire("❌ Error", "Failed to update status", "error");
    }
  };

  // ✅ View Payment Details
  const handleViewPayment = (user) => {
    if (!user.joiningPay) {
      Swal.fire("No Payment Found", "This user has not made any payment yet.", "info");
      return;
    }

    const { paidAt, tdrId, transactionId } = user.joiningPay;

    Swal.fire({
      title: "💳 Payment Details",
      html: `
        <p><strong>Paid At:</strong> ${paidAt || "N/A"}</p>
        <p><strong>TDR ID:</strong> ${tdrId || "N/A"}</p>
        <p><strong>Transaction ID:</strong> ${transactionId || "N/A"}</p>
      `,
      icon: "info",
      confirmButtonText: "Close"
    });
  };

  return (
    <>
      <div className="d-flex layout-container">
        <SideBar isOpen={isSidebarOpen} />

        <div className="flex-grow-1">
          <Header onMenuClick={toggleSidebar} />
          <div className="scrollable-section">
            <div className="p-4 shadow-md bg-white rounded" style={{ maxWidth: '1300px' }}>
              <h3 className="mb-4 fw-bold">User Management</h3>
              
              <Table bordered hover size="sm" className="custom-ai-table" striped responsive style={{ fontSize: '0.875rem' }}>
                <thead className="table-dark">
                  <tr>
                    <th>UID</th>
                    <th><FaUser /> Username</th>
                    <th><FaEnvelope /> Email</th>
                    <th><FaPhone /> Phone</th>
                    <th>Status</th>
                    <th>Change Status</th>
                    <th>Payment</th>
                  </tr>
                </thead>
                <tbody>
                  {leads.length > 0 ? leads.map(user => (
                    <tr key={user.uid}>
                      <td>{user.uid}</td>
                      <td>{user.username}</td>
                      <td>{user.email}</td>
                      <td>{user.phone}</td>
                      <td>
                        {user.status === "Verified" ? (
                          <span className="text-success fw-bold"><FaCheckCircle /> Verified</span>
                        ) : (
                          <span className="text-danger fw-bold"><FaTimesCircle /> NonVerified</span>
                        )}
                      </td>
                      <td>
                        <Button
                          size="sm"
                          variant={user.status === "Verified" ? "warning" : "success"}
                          onClick={() => handleStatusChange(user.uid, user.status)}
                        >
                          {user.status === "Verified" ? "Set NonVerified" : "Set Verified"}
                        </Button>
                      </td>
                      <td>
                        <Button
                          size="sm"
                          variant="info"
                          onClick={() => handleViewPayment(user)}
                        >
                          <FaMoneyBill /> View Payment
                        </Button>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="7" className="text-center">No users found</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminDashBoard;
